var map = {
	"./buttons.png": 53,
	"./buttons@2x.png": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;


//////////////////
// WEBPACK FOOTER
// ./sprite ^\.\/buttons.*\.png$
// module id = 111
// module chunks = d-game